export default __webpack_public_path__ + "static/media/dresser002.948bc94a.jpeg";